/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Payments_DescriptionInputs */

const en_settings_payments_description = /** @type {(inputs: Settings_Payments_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your payment history`)
};

const zh_settings_payments_description = /** @type {(inputs: Settings_Payments_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的付款历史`)
};

/**
* | output |
* | --- |
* | "Your payment history" |
*
* @param {Settings_Payments_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_payments_description = /** @type {((inputs?: Settings_Payments_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Payments_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_payments_description(inputs)
	return zh_settings_payments_description(inputs)
});
export { settings_payments_description as "settings.payments.description" }